import { response_t, saga_act } from 'src/types'
import { payment_t } from 'src/types/http/payment.types'

import { do_request } from './base.http'

/**
 * Payment
 */
export async function http_payment({
  args,
  type,
}: saga_act): Promise<response_t<payment_t>> {
  let value = await do_request<payment_t>({
    path: "/payment",
    args: args,
    saga_type: type,
  });

  return value;
}
